import React, { useState, useEffect } from 'react';

const SliderSection = () => {
  const [slides, setSlides] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loading, setLoading] = useState(true);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    const fetchSlides = async () => {
      try {
        const response = await fetch('https://fauconbleu.ma/api/pwa/banners/website');
        if (!response.ok) {
          throw new Error('Failed to fetch slides');
        }
        const data = await response.json();
        
        if (data && data.length > 0) {
          setSlides(data);
        }
      } catch (err) {
        console.warn('API fetch failed:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchSlides();
  }, []);

  useEffect(() => {
    if (slides.length > 0) {
      const interval = setInterval(() => {
        nextSlide();
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [slides.length, currentSlide]);

  const goToSlide = (index) => {
    if (!isTransitioning) {
      setIsTransitioning(true);
      setCurrentSlide(index);
      setTimeout(() => setIsTransitioning(false), 800);
    }
  };

  const nextSlide = () => {
    if (!isTransitioning) {
      setIsTransitioning(true);
      setCurrentSlide(prev => (prev + 1) % slides.length);
      setTimeout(() => setIsTransitioning(false), 800);
    }
  };

  const prevSlide = () => {
    if (!isTransitioning) {
      setIsTransitioning(true);
      setCurrentSlide(prev => prev === 0 ? slides.length - 1 : prev - 1);
      setTimeout(() => setIsTransitioning(false), 800);
    }
  };

  if (loading || slides.length === 0) {
    return null;
  }

  const getSlidePosition = (index) => {
    const diff = index - currentSlide;
    const halfLength = Math.floor(slides.length / 2);
    
    if (diff > halfLength) {
      return diff - slides.length;
    } else if (diff < -halfLength) {
      return diff + slides.length;
    }
    return diff;
  };

  return (
    <>
      <style jsx>{`
        .slider-section {
          position: relative;
          overflow: hidden;
          min-height: 300px;
          max-height: 600px;
          height: 60vh;
          margin: 0;
          padding: 0;
        }

        .slider-container {
          position: relative;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }

        .slides-track {
          position: relative;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
        }

        .slide {
          position: absolute;
          max-width: 1000px;
          height: 85%;
          left: 50%;
          background:transparent;
          top: 50%;
          transform: translate(-50%, -50%);
          transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        }

        .slide-inner {
          width: 100%;
          position: relative;
          cursor: pointer;
          border-radius: 10px;
          overflow: hidden;
          background: transparent;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
        }

        .slide-image {
          width: 100%;
          border-radius: 10px;
          height: 100%;
          object-fit: contain;
          object-position: center;
          background: white;
        }

        .slide-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(to bottom, transparent 70%, rgba(0,0,0,0.1) 100%);
          opacity: 0;
          transition: opacity 0.3s ease;
          pointer-events: none;
        }

        .slide:hover .slide-overlay {
          opacity: 1;
        }

        .slider-dots {
          position: absolute;
          bottom: 30px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          gap: 12px;
          z-index: 10;
          padding: 10px 20px;
          background: rgba(0, 0, 0, 0.3);
          border-radius: 30px;
          backdrop-filter: blur(10px);
        }

        .dot {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.6);
          cursor: pointer;
          transition: all 0.3s ease;
          border: none;
          outline: none;
        }

        .dot:hover {
          background: rgba(255, 255, 255, 0.9);
          transform: scale(1.3);
        }

        .dot:focus {
          outline: 2px solid rgba(255, 255, 255, 0.8);
          outline-offset: 2px;
        }

        .dot.active {
          background: #4FC3F7;
          transform: scale(1.3);
        }

        .nav-arrow {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: rgba(255, 255, 255, 0.95);
          border: none;
          border-radius: 50%;
          width: 50px;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          font-size: 20px;
          color: #333;
          z-index: 10;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
          backdrop-filter: blur(10px);
        }

        .nav-arrow:hover {
          background: white;
          transform: translateY(-50%) scale(1.1);
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
        }

        .nav-arrow:focus {
          outline: 3px solid rgba(79, 195, 247, 0.6);
          outline-offset: 2px;
        }

        .nav-arrow.prev {
          left: 20px;
        }

        .nav-arrow.next {
          right: 20px;
        }

        @media (max-width: 1024px) {
          .slider-section {
            height: 50vh;
            min-height: 250px;
            max-height: 500px;
          }

          .slide {
            width: 80%;
          }

          .nav-arrow {
            width: 45px;
            height: 45px;
            font-size: 18px;
          }
        }

        @media (max-width: 768px) {
          .slider-section {
            height: 40vh;
            min-height: 200px;
            max-height: 400px;
          }

          .slide {
            width: 85%;
            height: 80%;
          }

          .slide-inner {
            border-radius: 15px;
          }

          .slider-dots {
            bottom: 20px;
            padding: 8px 16px;
          }

          .dot {
            width: 10px;
            height: 10px;
          }

          .nav-arrow {
            width: 40px;
            height: 40px;
            font-size: 16px;
          }

          .nav-arrow.prev {
            left: 15px;
          }

          .nav-arrow.next {
            right: 15px;
          }
        }

        @media (max-width: 480px) {
          .slider-section {
            height: 35vh;
            min-height: 180px;
            max-height: 300px;
          }

          .slide {
            width: 90%;
            height: 75%;
          }

          .slide-inner {
            border-radius: 10px;
          }

          .slider-dots {
            bottom: 15px;
            gap: 8px;
            padding: 6px 12px;
          }

          .dot {
            width: 8px;
            height: 8px;
          }

          .nav-arrow {
            width: 35px;
            height: 35px;
            font-size: 14px;
          }

          .nav-arrow.prev {
            left: 10px;
          }

          .nav-arrow.next {
            right: 10px;
          }
        }

        .sr-only {
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          white-space: nowrap;
          border: 0;
        }
      `}</style>

      <section 
        className="slider-section"
        role="region"
        aria-labelledby="slider-heading"
        aria-live="polite"
        itemScope
        itemType="https://schema.org/ImageGallery"
      >
        <h2 id="slider-heading" className="sr-only">
          Galerie d'images Faucon Bleu
        </h2>

        <div className="slider-container">
          <div className="slides-track" role="group" aria-label="Carrousel d'images">
            {slides.map((slide, index) => {
              const position = getSlidePosition(index);
              const isActive = position === 0;
              const isPrev = position === -1;
              const isNext = position === 1;
              const isVisible = Math.abs(position) <= 1;

              if (!isVisible) return null;

              const translateX = position * 100;
              const scale = isActive ? 1 : 0.85;
              const opacity = isActive ? 1 : 0.6;
              const zIndex = isActive ? 3 : isPrev || isNext ? 2 : 1;

              return (
                <div
                  key={slide.id || index}
                  className="slide"
                  style={{
                    transform: `translate(calc(-50% + ${translateX}%), -50%) scale(${scale})`,
                    opacity: opacity,
                    zIndex: zIndex,
                    pointerEvents: isActive ? 'auto' : 'none'
                  }}
                  role="img"
                  aria-label={`Image ${index + 1} sur ${slides.length}`}
                  aria-hidden={!isActive}
                  itemProp="associatedMedia"
                  itemScope
                  itemType="https://schema.org/ImageObject"
                  onClick={() => isActive && goToSlide(index)}
                >
                  <div className="slide-inner">
                    <img
                      className="slide-image"
                      src={`https://fauconbleu.ma/storage/${slide.image_path}`}
                      alt={`Slide ${index + 1}`}
                      loading={isActive ? "eager" : "lazy"}
                      itemProp="contentUrl"
                    />
                    <div className="slide-overlay" />
                  </div>
                </div>
              );
            })}
          </div>

          <button
            className="nav-arrow prev"
            onClick={prevSlide}
            aria-label="Image précédente"
            disabled={isTransitioning}
          >
            &#8249;
          </button>

          <button
            className="nav-arrow next"
            onClick={nextSlide}
            aria-label="Image suivante"
            disabled={isTransitioning}
          >
            &#8250;
          </button>
        </div>

        <div className="slider-dots" role="tablist" aria-label="Navigation du carrousel">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              role="tab"
              aria-selected={index === currentSlide}
              aria-label={`Aller à l'image ${index + 1}`}
              disabled={isTransitioning}
            />
          ))}
        </div>

        <script 
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "ImageGallery",
              "name": "Galerie Faucon Bleu",
              "description": "Images des services automobiles Faucon Bleu",
              "publisher": {
                "@type": "Organization",
                "name": "Faucon Bleu",
                "url": "https://faucon-bleu.ma"
              },
              "associatedMedia": slides.map((slide, index) => ({
                "@type": "ImageObject",
                "contentUrl": `https://fauconbleu.ma/storage/${slide.image_path}`,
                "name": `Image Faucon Bleu ${index + 1}`,
                "description": "Services automobiles Faucon Bleu"
              }))
            })
          }}
        />
      </section>
    </>
  );
};

export default SliderSection;